import { render, staticRenderFns } from "./NeqasSamplesIndexComponent.vue?vue&type=template&id=749f0262"
import script from "./NeqasSamplesIndexComponent.vue?vue&type=script&lang=js"
export * from "./NeqasSamplesIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports